module.exports = __webpack_public_path__ + "static/media/auto-skip.0f545cf7.png";